module Meevo.Components.Common {
    /**
     * Contract to hold string constants used through out the client side application.
     * All of these constants are partially used in walking manager and egifts plugins.
     * Using static get() functions so that the members can't be changed by anyone
     */
    export class NotificationTags {

        public static get WALKIN_POSITION(): any { return 'WalkInPosition'; }

        public static get WALKIN_ETA(): any { return 'WalkInETA'; }

        public static get CLIENT_FIRSTNAME(): any { return 'Client.FirstName'; }

        public static get WALKIN_URL(): any { return 'WalkInUrl'; }

        public static get EMPLOYEE(): any { return 'Employee'; }

        public static get SERVICE(): any { return 'Service'; }

        public static get BUSINESS_NAME(): any { return 'BusinessInfo.Name'; }

        public static get EGIFT_FROM(): any { return 'From'; }

        public static get EGIFT_TO(): any { return 'To'; }

        public static get BUSINESS_ADDRESS_ADDRESS_1(): any { return 'BusinessInfo.Address.Address1'; }

        public static get BUSINESS_ADDRESS_ADDRESS_2(): any { return 'BusinessInfo.Address.Address2'; }

        public static get BUSINESS_ADDRESS_CITY(): any { return 'BusinessInfo.Address.City'; }

        public static get BUSINESS_ADDRESS_STATE(): any { return 'BusinessInfo.Address.State'; }

        public static get BUSINESS_ADDRESS_ZIP_CODE(): any { return 'BusinessInfo.Address.ZipCode'; }

        public static get BUSINESS_EMAIL_ADDRESS(): any { return 'BusinessInfo.EmailAddress'; }

        public static get BUSINESS_PHONE_NUMBER(): any { return 'BusinessInfo.PhoneNumber'; }

        public static get EGIFT_FROMS_EMAIL(): any { return 'EmailFrom'; }

        public static get EGIFT_VALUE(): any { return 'EgiftValue'; }

        public static get EGIFT_NUMBER(): any { return 'EgiftNumber'; }

        public static get EGIFT_LINK(): any { return 'VieweGiftLink'; }

        public static get EGIFT_PROMOTION_CODE(): any { return 'PromoCode'; }

        public static get EGIFT_DELIVERY_METHOD(): any { return 'DeliveryMethod'; }

        public static get EGIFT_SHIP_TO_ADDRESS(): any { return 'ShipToAddress'; }

        public static get EGIFT_TRANSACTION_NUMBER(): any { return 'TransactionNumber'; }

        public static get EGIFT_SHIPPING_FEE(): any { return 'ShippingFee'; }

        public static get EGIFT_PROCESSING_FEE(): any { return 'ProcessingFee'; }

        public static get BOOK_NOW(): any { return 'BookNow'; }

        public static get CUSTOM_BRANDING_LOGO(): any { return 'CustomBrandingLogo'; }

        public static get SOCIAL_MEDIA_FACEBOOK(): any { return 'SocialMedia.Facebook'; }

        public static get SOCIAL_MEDIA_INSTAGRAM(): any { return 'SocialMedia.Instagram'; }

        public static get SOCIAL_MEDIA_PINTEREST(): any { return 'SocialMedia.Pinterest'; }

        public static get SOCIAL_MEDIA_TWITTER(): any { return 'SocialMedia.Twitter'; }

        public static get SOCIAL_MEDIA_YOUTUBE(): any { return 'SocialMedia.YouTube'; }

        public static get SHIPPING_RATE_DISPLAY_NAME(): any { return 'ShippingRateDisplayName'; }

        public static get TRACKING_NUMBER(): any { return 'TrackingNumber'; }

        public static get ITEM_TYPE(): any { return 'ItemType'; }

        public static get ITEM_DISPLAY_NAME(): any { return 'ItemDisplayName'; }

        public static get SERVICE_PACKAGE_INFORMATION(): any { return 'ServicePackageInformation'; }
    }
}